import styled, { css } from "styled-components";
import theme from "../../../Themes/light";

const { colors } = theme;

const commonStyles = css`
  display: contents;
  .containerFreteEspecialListagem {
    width: 100%;
    max-width: 90vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;

    .titulo{
      margin-bottom: 0;
    }

    .textoFreteEspecial{
      text-align: left;
      padding: 3rem 0 0;
      width: 90%;
      color: ${(props) => props.theme.colors.tertiary};
      position: relative;
    }

    .linha{
      width: 30%;
      height: 2px;
      border-radius: 100%;
      background-color: ${(props) => props.theme.colors.elements};
    }

    .filtros-frete{
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 2rem;

      .select-filtro-fretes{
        width: 20%;

        @media (max-width: 768px) {
          width: 40%;
        }
      }

      .busca-fretes{
        flex-grow: 1;
      }
    }

    .fretesFlexContainer {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      width: 90%;
      .tableContainer{
        width: 100%;
        >table{
          >thead{
            >tr{
              >th{
                .th-wrapper{
                  padding: 2rem;
                }
              }
            }
          }
        }
        .editar{
          color: ${(props) => props.theme.colors.primary};
          cursor: pointer;
        }
      }
    }

    .rodapeFretes {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr auto 1fr;
      align-items: center;
      gap: 2rem;

      .paginacaoFretes > div {
        justify-content: flex-start;
      }

      @media (max-width: 768px) {
        display: flex;
        flex-direction: column;

        .paginacaoFretes > div {
          justify-content: center;
        }
      }
    }

    > .novo {
      text-align: center;
      color: ${(props) => props.theme.colors.primary};
      cursor: pointer;
      min-height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const ContainerFreteEspecialListagem = styled.div<{
  configIn: "empresa" | "configuracoes";
}>`
  ${commonStyles};
  ${({ configIn }) =>
    configIn === "configuracoes" &&
    css`
      .containerFreteEspecialListagem {

        .textoFreteEspecial{
          padding: 3rem 0;
          width: 100%;
        }

        .fretesFlexContainer{
          width: 100%;
          .tableContainer{
            width: 100%;
          }
        }

        .novo {
          text-align: center;
        }
      }
    `}
`;

// Add other styled components for the nested elements if necessary
